

// plugins
import Vue from 'vue'
import axios from 'axios';
import Vuex from 'vuex'

// Helpers 
import {    
    getCollections, 
    newJob, 
    overridecollection,
    addUpdateCollection,
    cleanrecord
} from '@/helpers/localbase'

// mixins 
import {orderboxmixins} from '@/mixins/orderboxmixins'



Vue.use(Vuex)

const defaultstate = () => {
    return  {
        /**
         * Window size
         */
        windowsize : {
            width      : window.innerWidth,
            innerHeight: window.innerHeight
        },
        /**
         * Subscription edit flags
         */
        editsubscriptionflags : {
            boxchanges : false,
            datechanges: false
        },
        /**
         * Active user creditcards
         */
        usercreditcards: [],
        /**
         * Route from previous page
         */
        routefrom : null,
        /**
         * Type of order 
         * Order subscription or Order for event
         */
        issubscription: true,
        /**
         * Card token is generated from card connect
         */
        cardconnectdetails: null,
        /**
         * Order types
         */
        ordertypes :  [],
        /**
         * Min order box setting
         */
        minbox    : 3,
        /**
         * Default value 
         * Order will have default boxes base on min box setting
         */
        orderboxes: [],
        /**
         * Active user object
         */
        user      : null,
        /**
         * Network status
         */
        isonline  : true,
        /**
         * Session status
         */
        islogin   : false,
        /**
         * Flavors is set here so that we only have 1 place to manage the flavors.
         */
        flavors   : [],
        /**
         * User subscriptions
         */
        subscriptions: [],
        /**
         * Settings from admin
         */
        settings: [],
        /**
         * Navigation menues
         */
        menus : [
            {
                name  : 'Flavors',
                allias: 'Flavor(s)',
                route : 'home',
                icon  : 'heart'
            },
            {
                name : 'Order for Event',
                allias: 'Order for event',
                route : 'orderforevent',
                icon : 'cart4'
            },
            {
                name  : 'Start order',
                allias: 'Edit order',
                route : 'product',
                icon  : 'cart3'
            },
            {
                name  : 'Account',
                allias: 'profile',
                route : 'ordersubscription',
                icon  : 'person-circle'
            },
        ],
        /**
         * Socket io / Webhook
         */
        socketio: null
  }
}

export default new Vuex.Store({
    state: defaultstate(),
    mutations: {
        updateeditsubflag(state, payload) {
            state.editsubscriptionflags = payload;
        },
        updatesocketio(state, payload) {
            state.socketio = payload;
        },
        updateminsubsorder(state, payload) {
            state.minbox = payload;
        },
        updatesettings(state, payload) {
            state.settings = payload;
        },
        updateboxtypes(state, payload) {
            state.ordertypes = payload;
        },
        updateflavors(state, payload) {
            state.flavors = payload;
        },
        updateusercreditcards(state, payload) {
            state.usercreditcards = payload;
        },
        updateroutefrom(state, payload) {
            state.routefrom = payload;
        },
        updateordertype(state, payload) {
            state.issubscription = payload;
        },
        updatecarddetails(state, payload) {
            state.cardconnectdetails = payload;
        },
        updateorderboxes(state, payload) {
            state.orderboxes = payload;
        },
        updateloginstatus(state, payload) {
            state.islogin = payload;
        },
        updatenetworkstatus(state, payload) {
            state.isonline = payload;
        },
        updateSubscriptions(state, payload) {
            state.subscriptions = payload;
        },
        updateUser(state, payload) {
            state.user = payload;
        },
        resetstates(state) {
            Object.assign(state, defaultstate());
        },
        udpatewindowsize(state, payload) {
            state.windowsize = payload
        }
    },
    actions: {
        /**
         * Reset states after logging out
         *
         */
        resetstates(context) {
            context.commit("resetstates");
        },
        /**
         * Get settings
         * @param {Object} context
         */
        async getsettings(context) {
            /**
             * Pull from indexeddb first
             */
            const isettings = await getCollections({ name: "settings" });
            context.commit("updatesettings", isettings);
            /**
             * Axios request
             */
            const url = "/holes_settings";
            const asettings = await axios
                .post(url)
                .catch((err) => console.log(err));

            if (asettings.data.success) {
                context.commit("updatesettings", asettings.data.data);

                asettings.data.data.forEach((setting) => {
                    addUpdateCollection({ name: "settings", data: setting });
                });

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(asettings.data.data, isettings, "id", "settings");
            } else if (!context.state.isonline) {
                // if offline add request to job
                newJob({
                    url: url,
                    method: "POST",
                    callback: (data, options) => {
                        /**
                         * Check if success
                         * then update store settings state
                         */

                        if (data.success) {
                            options.store.commit("updatesettings", data.data);

                            data.data.forEach((setting) => {
                                addUpdateCollection({
                                    name: "settings",
                                    data: setting,
                                });
                            });
                        }
                    },
                });
            }
        },
        /**
         * Get box types
         * pull from index db first
         * run cleanup function for trashed data
         */
        async getboxtypes(context) {
            const itypes = await getCollections({ name: "boxes" });
            context.commit("updateboxtypes", itypes);

            const url = "/boxes";
            const atypes = await axios
                .get(url)
                .catch((err) => console.log(err));

            if (atypes && atypes.data.success) {
                const newtypes = atypes.data.data;

                context.commit("updateboxtypes", newtypes);

                for (let index = 0; index < newtypes.length; index++) {
                    const type = newtypes[index];

                    addUpdateCollection({ name: "boxes", data: type });
                }

                /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newtypes, itypes, "id", "boxes");
            } else if (!context.state.isonline) {
                /**
                 * if offline add request to job
                 */
            }
        },
        /**
         * Get flavors set by admin
         * pull on indexed db first
         * run cleanup function for trashed data
         */
        async getflavors(context) {
            const iflavors = await getCollections({ name: "flavors" });

            /**
             * Get active flavors's
             * sort by ranking
             */
            const inewranking = iflavors
                .slice()
                .sort((a, b) => a.ranking - b.ranking);

            context.commit("updateflavors", inewranking);

            const url = "/flavors";
            const aflavors = await axios
                .get(url)
                .catch((err) => console.log(err));

            if (aflavors && aflavors.data.success) {
                const newflavors = aflavors.data.data.filter(
                    (f) => f.is_active
                );

                /**
                 * Get active flavors's
                 * sort by ranking
                 */
                const anewranking = newflavors
                    .slice()
                    .sort((a, b) => a.ranking - b.ranking);
                context.commit("updateflavors", anewranking);

                for (let index = 0; index < newflavors.length; index++) {
                    const flavor = newflavors[index];

                    addUpdateCollection({ name: "flavors", data: flavor });
                }

                /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newflavors, iflavors, "id", "flavors");
            } else if (!context.state.isonline) {
                /**
                 * if offline add request to job.
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        /**
                         * Check if success
                         * update indexed records
                         * and store flavors
                         */
                        const newflavors = data.data;

                        if (data.success) {
                            options.store.commit("updateflavors", newflavors);

                            for (
                                let index = 0;
                                index < newflavors.length;
                                index++
                            ) {
                                const flavor = newflavors[index];

                                options.db.addUpdateCollection({
                                    name: "flavors",
                                    data: flavor,
                                });
                            }
                        }
                    },
                });
            }
        },
        /**
         * Get user credit cards
         * Pull in index db first
         */
        async getcreditcards(context, userid) {
            const url = "/creditcards";
            const cards = await getCollections({
                name: "usercreditcards",
                filter: { key: "user_id", value: userid },
            });

            context.commit("updateusercreditcards", cards);

            const apicards = await axios.get(url);

            if (apicards.data.success) {
                const newcards = apicards.data.data.map((c) => {
                    c.user_id = userid;
                    return c;
                });
                context.commit("updateusercreditcards", newcards);

                for (let index = 0; index < newcards.length; index++) {
                    const card = newcards[index];

                    addUpdateCollection({
                        name: "usercreditcards",
                        data: card,
                    });
                }

                /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newcards, cards, "id", "usercreditcards");
            } else if (!context.state.isonline) {
                /**
                 * Failed were going to register this to cron jobs
                 *
                 */
                newJob({
                    url: url,
                    method: "GET",
                    params: { user_id: userid },
                    callback: (data, options) => {
                        const newdata = data.data ? data.data : data;
                        const cards = newdata.map((c) => {
                            c.user_id = options.job.params.user_id;

                            return c;
                        });
                        options.store.commit("updateusercreditcards", cards);

                        // update localbase
                        for (let index = 0; index < cards.length; index++) {
                            const card = cards[index];

                            options.db.addUpdateCollection({
                                name: "usercreditcards",
                                data: card,
                            });
                        }
                    },
                });
            }
        },
        /**
         * Get user subscriptoins
         */
        async getSubscriptions(context) {
            /**
             * Get data from indexed db first
             * before calling api
             * Were use vuex to update data from job collection of api request from job succeed.
             */
            const url = "/subscriptions";
            const subscriptions = await getCollections({
                name: "subscriptions",
            });

            context.commit("updateSubscriptions", subscriptions);

            const subs = await axios.get(url);

            if (subs.data.success) {
                const newdata = subs.data.data;
                context.commit("updateSubscriptions", newdata);

                for (let index = 0; index < newdata.length; index++) {
                    const sub = newdata[index];

                    addUpdateCollection({ name: "subscriptions", data: sub });
                }

                /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newdata, subscriptions, "id", "subscriptions");
            } else if (!context.state.isonline) {
                /**
                 * Failed were going to register this to cron jobs
                 *
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        const newdata = data.data ? data.data : data;
                        options.store.commit("updateSubscriptions", newdata);

                        for (let index = 0; index < newdata.length; index++) {
                            const sub = newdata[index];

                            options.db.addUpdateCollection({
                                name: "subscriptions",
                                data: sub,
                            });
                        }
                    },
                });
            }
        },
        async getUser(context) {
            /**
             * Get data from indexed db first
             * before calling api
             */

            const user = await getCollections({ name: "user" });
            const url = `/profile`;

            if (user) {
                context.commit("updateUser", user);
            }

            /**
             * Get user via api call
             */
            const apiuser = await axios
                .get(url)
                .catch((err) => console.log(err));

            if (apiuser && apiuser.data.success) {
                const user = apiuser.data.data;
                context.commit("updateUser", user);
                overridecollection({ name: "user", data: [user] });
            } else if (!context.state.isonline) {
                /**
                 * If failed add api call to job
                 * there it will call for certian times
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        const newData = data.data ? data.data : data;
                        options.store.commit("updateUser", newData);
                        options.db.addUpdateCollection({
                            name: "user",
                            data: newData,
                        });
                    },
                });
            }
        },
        /**
         * Get subscription box items
         * pull from indexed db first
         */
        async getsubboxitems(context, subid) {
            /**
             * Data from indexdb
             */
            const iboxitems = await getCollections({
                name: "boxitems",
                filter: { key: "sub_id", value: subid },
            });
            /** update store state */
            context.commit("updateorderboxes", iboxitems);

            /**
             * api request
             */
            const url = "/subscription/box_items";
            const res = await axios.get(url).catch((err) => console.log(err));

            if (res.data.success) {
                const toarray = Object.values(res.data.data);
                const newdatatemp = toarray.map((item, index) =>
                    orderboxmixins.methods.restractureboxproperty(
                        item,
                        subid,
                        index
                    )
                );

                /**
                 * Change flavor_id to id
                 */
                const newdata = newdatatemp.map((item) => {
                    item.flavors = item.flavors.map((f) => {
                        f.id = f.flavor_id;

                        return f;
                    });

                    return item;
                });

                console.table(newdata);
                /**
                 * update store state
                 * and indexeddb
                 * */
                context.commit("updateorderboxes", newdata);

                for (let index = 0; index < newdata.length; index++) {
                    const item = newdata[index];

                    addUpdateCollection({ name: "boxitems", data: item });
                }

                /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newdata, iboxitems, "id", "boxitems");
            } else if (!this.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url: url,
                    method: "GET",
                    params: { subid: subid },
                    callback: (data, options) => {
                        /**
                         * Check if succeed
                         * and update store state
                         * and indexeddb
                         */
                        if (data.success) {
                            const newdata = data.data
                                .map((item, index) => {
                                    item.groupid = index;
                                    return item;
                                })
                                .map((item) => restracture(item));
                            /**
                             * update store state
                             * and indexeddb
                             * */

                            /**
                             * Re-stracture data
                             * check ordermixins.js newboxproperty function for properties we need
                             * (type) this property will be remove in future so avoid using it
                             * (price) this property will be remove in future so avoid using it
                             * (flavors) this property will be the id's of the flavor
                             * (flavorfull) this property will have full data properties of the flavor
                             */
                            const restracture = (dataobj) => {
                                return {
                                    id: dataobj.box_id,
                                    box_name: dataobj.box_name,
                                    type: dataobj.box_id,
                                    flavors: dataobj.flavors,
                                    price: 0,
                                    sub_id: options.job.params.subid,
                                    group_id: dataobj.groupid,
                                };
                            };

                            options.store.commit("updateorderboxes", newdata);

                            for (
                                let index = 0;
                                index < newdata.length;
                                index++
                            ) {
                                const item = newdata[index];

                                options.db.addUpdateCollection({
                                    name: "boxitems",
                                    data: item,
                                });
                            }
                        }
                    },
                });
            }
        },
    },
    modules: {},
});
